import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import { FiCheck, FiAlertTriangle } from 'react-icons/fi';

const SegmentationPanel = ({ segments }) => {
  if (!segments || segments.length === 0) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="mt-6 pt-6 border-t border-gray-100 space-y-6"
    >
      {segments.map((dim) => {
        const label = dim.question_text || dim.tag_key || 'Dimension';
        const displayLabel = label.length > 40 ? `${label.substring(0, 40)}...` : label;

        return (
          <div key={dim.tag_key}>
            <h4 className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-3 flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-rutabaga-pink"></span>
              {displayLabel}
            </h4>
            <div className="space-y-3">
              {dim.targets.map((target) => {
                const isMet = target.actual >= target.target_count;
                const hasData = target.actual > 0;
                const percentage = Math.min((target.actual / target.target_count) * 100, 100);

                return (
                  <div key={target.category_value} className="space-y-1.5">
                    <div className="flex justify-between items-end text-xs">
                      <span className="font-bold text-rutabaga-dark">{target.category_value}</span>
                      <div className="flex items-center gap-2">
                        <span className="font-black text-[10px] text-gray-500">
                          {target.actual} / {target.target_count}
                        </span>
                        {isMet ? (
                          <SafeIcon icon={FiCheck} className="text-emerald-500 font-bold" />
                        ) : hasData ? (
                          <SafeIcon icon={FiAlertTriangle} className="text-amber-500" />
                        ) : null}
                      </div>
                    </div>
                    <div className="h-1.5 w-full bg-gray-100 rounded-full overflow-hidden">
                      <motion.div
                        initial={{ width: 0 }}
                        animate={{ width: `${percentage}%` }}
                        className={`h-full rounded-full ${isMet ? 'bg-emerald-500' : 'bg-amber-500'}`}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </motion.div>
  );
};

export default SegmentationPanel;